import { useEffect, useMemo, useState } from 'react';
import { images } from '../../../Constants/ImageUrls';
import AnywhereHorizontalScroll from '../../HelperComponents/AnywhereHorizontalScroll';
import {
  BlackEighty,
  ProductColorContainer,
  ProductColorCover,
  ProductColorUl,
} from '../ProductColor/styled';
import ProductColorInner from '../ProductColor/ProductColorInner';

export default function ProductType(props) {
  const {
    varientData,
    clickProductColorHandler,
    varientTitle,
    selectedData,
    productDetail,
    showNewDiaperVariantUx,
  } = props;
  const key = 'title';
  const varientArray = [...varientData];
  const arrayUniqueByKey = useMemo(() => {
    return [...new Map(varientArray.map((item) => [item[key], item])).values()];
  }, [varientData]);
  const [focusElement, setFocusElement] = useState();
  const customReducerState = selectedData;
  const variantOptions = productDetail?.variantOption;
  const notSingleVariant = variantOptions?.length > 1;

  const applyGestureEffect = (index) => {
    setFocusElement(index);
    setTimeout(() => {
      setFocusElement(null);
    }, 350);
  };
  const productClickHandler = (
    customReducerState = [],
    variantOptions = [],
    fallbackId,
    variantDetails,
  ) => {
    let shortListedItem = [];
    const combinedState = { ...customReducerState, ...variantDetails };
    let selectedElement = {};
    variantOptions.forEach((item, index) => {
      let outterIndex = index;
      item.data.forEach((data) => {
        if (
          data.title == combinedState[item?.variant_type?.toUpperCase()] &&
          outterIndex === 0
        ) {
          shortListedItem.push(data.web_url);
        } else if (
          data.title != combinedState[item?.variant_type?.toUpperCase()] &&
          outterIndex != 0
        ) {
          let indexValue = shortListedItem.indexOf(data.web_url);
          if (indexValue > -1) {
            shortListedItem.splice(indexValue, 1);
          }
        }
        const indexOfResult = item.data.findIndex(
          (i) => i.web_url == shortListedItem.toString(),
        );
        selectedElement = item.data[indexOfResult];
      });
    });

    clickProductColorHandler(
      shortListedItem.length > 0
        ? shortListedItem.toString()
        : fallbackId?.web_url
          ? fallbackId?.web_url
          : fallbackId?.product_id?.toString(),
      shortListedItem.length > 0 ? selectedElement : fallbackId,
      varientTitle,
      combinedState[varientTitle.toUpperCase()],
    );
  };
  const productColorClickHandler = (element) => {
    const variantDetails = {};
    variantDetails['productId'] = element?.product_id;
    variantDetails[varientTitle.toUpperCase()] = element?.title;
    variantDetails['SizesAvailable'] = varientData.map((item) => {
      if (item?.title === element?.title) return item?.product_id;
    });
    productClickHandler(
      customReducerState,
      variantOptions,
      element,
      variantDetails,
    );
  };
  useEffect(() => {
    arrayUniqueByKey?.map((element, index) => {
      if (customReducerState[varientTitle.toUpperCase()] == element?.title) {
        const myElement = document?.getElementById(`${element.name + index}`);

        function getOffset(el) {
          let _x = 0;
          let _y = 0;
          while (el && !isNaN(el?.offsetLeft) && !isNaN(el?.offsetTop)) {
            _x += el?.offsetLeft - el?.scrollLeft;
            _y += el?.offsetTop - el?.scrollTop;
            el = el.offsetParent;
          }
          return { top: _y, left: _x };
        }

        let x = getOffset(myElement).left;
        if (document.getElementById(`colorBoxOutter`)) {
          document.getElementById(`colorBoxOutter`).scrollLeft = x - 30;
        }
      }
    });
  }, [selectedData]);
  return (
    <ProductColorContainer>
      <ProductColorCover>
        <span className="head">{varientTitle}:&nbsp;</span>
        <BlackEighty>
          {customReducerState[varientTitle.toUpperCase()]}
        </BlackEighty>
      </ProductColorCover>

      <ProductColorUl
        notSingleVariant={notSingleVariant}
        id="colorBoxOutter"
        showNewDiaperVariantUx={showNewDiaperVariantUx}
      >
        <AnywhereHorizontalScroll
          firstElementId={`${arrayUniqueByKey[0]?.title}first`}
          lastElementId={`${
            arrayUniqueByKey[arrayUniqueByKey?.length - 1]?.title
          }last`}
          leftArrow={<img src={images.arrowdownforward} alt="" />}
          rightArrow={<img src={images.arrowdownforward} alt="" />}
          scrolledWidth={440}
        >
          {arrayUniqueByKey?.map((element, index) => {
            return (
              <ProductColorInner
                key={index}
                productColorClickHandler={productColorClickHandler}
                element={element}
                varientTitle={varientTitle}
                index={index}
                arrayUniqueByKey={arrayUniqueByKey}
                focusElement={focusElement}
                customReducerState={customReducerState}
                notSingleVariant={notSingleVariant}
                applyGestureEffect={applyGestureEffect}
              />
            );
          })}
        </AnywhereHorizontalScroll>
      </ProductColorUl>
    </ProductColorContainer>
  );
}
